export default "__VITE_ASSET__7246f2a2__"